import SetupRmGghyptSmsModal from './setup-rm-gghypt-sms-modal.vue'
export default SetupRmGghyptSmsModal
